
import { Link } from 'react-router-dom';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function ConsignmentHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#1A2332] via-[#2C3E55] to-[#1A2332] text-white pt-16 lg:pt-20 pb-20">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/ecc7cc75b95304d51cf2443625b8510c.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <Breadcrumb
          items={[
            { label: 'Home', path: '/' },
            { label: 'Consignment' },
          ]}
        />

        <div className="max-w-4xl mx-auto text-center mt-8">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
            <i className="ri-hand-coin-line text-[#E8B84B]"></i>
            <span className="text-sm font-medium">Sell Smarter. Keep More. Do Less.</span>
          </div>

          <h1 className="font-oswald text-5xl md:text-6xl font-bold mb-6">
            Sell Your Car for What It's{' '}
            <span className="text-[#E8B84B]">Actually Worth</span>
          </h1>

          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Private sales are a part-time job. Trade-ins are a rip-off. Consignment with Rockhound is neither — 
            we handle everything while you get retail money. No tire-kickers, no Craigslist strangers, no surprises.
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="#consignment-form"
              className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
            >
              <i className="ri-file-list-line text-xl"></i>
              Let's Sell Your Car
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              Talk to a Human
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-6 mt-12">
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-money-dollar-circle-line text-[#4ADE80] text-xl"></i>
              <span>Retail Value, Not Wholesale</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-shield-check-line text-[#4ADE80] text-xl"></i>
              <span>We Handle Every Detail</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <i className="ri-time-line text-[#4ADE80] text-xl"></i>
              <span>Most Sell in 30–45 Days</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
